<template>
  <div class="relative">
    <template v-if="type == 'textarea'">
      <span
        v-if="legendText && model.length"
        class="bg-white text-grey-mid absolute translate-y-[-50%] left-[10px] text-[10px] uppercase text-ellipsis overflow-hidden max-w-[50%] whitespace-nowrap px-[4px]"
      >
        {{ text }}
      </span>
      <textarea
        v-model="model"
        :placeholder="text"
        :class="[inputClasses]"
        class="border border-grey-pale text-charcoal rounded-[6px] p-[11px] w-full h-full max-h-[128px] bg-white outline-0 transition-all"
        @input="handleInput"
      ></textarea>
    </template>
    <template v-else>
      <span
        v-if="legendText && model.length"
        class="bg-white text-grey-mid absolute translate-y-[-50%] left-[10px] text-[10px] uppercase text-ellipsis overflow-hidden max-w-[50%] whitespace-nowrap px-[4px]"
      >
        {{ text }}
      </span>
      <div
        class="flex items-center"
        :class="{ 'h-[36px]': smallSize, 'h-[48px]': !smallSize }"
      >
        <input
          v-model="model"
          v-bind="$attrs"
          :type="type"
          :class="[
            'border border-grey-pale text-charcoal rounded-[6px] p-[11px] w-full h-full bg-white outline-0 transition-all',
            { 'pr-[22px]': icon },
            inputClasses,
          ]"
          :placeholder="text"
          @input="handleInput"
        />
        <InlineSvg
          v-if="icon"
          :src="`/assets/svg/icons/${icon}.svg`"
          class="cursor-pointer absolute right-[11px]"
          :class="iconClasses"
          @click="emit('icon-clicked')"
        />
      </div>
    </template>
    <span
      v-for="err in errors"
      :key="err.$uid"
      class="text-red-alert block mt-[5px] text-[13px]"
    >
      {{ err.$message }}
    </span>
  </div>
</template>
<script setup>
import { ref, watch } from 'vue';

const emit = defineEmits(['update:modelValue', 'icon-clicked']);
const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: '',
  },
  errors: {
    type: Array,
    default: () => [],
  },
  type: {
    type: String,
    default: 'text',
  },
  text: {
    type: String,
    default: '',
  },
  legendText: {
    type: Boolean,
    default: true,
  },
  smallSize: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: '',
  },
  inputClasses: {
    type: String,
    default: '',
  },
  iconClasses: {
    type: String,
    default: '',
  },
});

watch(
  () => props.modelValue,
  (newVal) => {
    model.value = newVal;
  }
);
const model = ref(props.modelValue);
const handleInput = () => {
  emit('update:modelValue', model.value);
};
</script>
